export default ({type, className}) => (
  <div className={`upload-badge ${className}` || ''}>
    {type}
  </div>
);
